import React from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { gql } from '@apollo/client'
import { Loading } from '@website2018/da-dobsonville'
import Article from '../../components/Newsroom/Article'
import MetaHeader from '../../components/Newsroom/MetaHeader'
import { Redirect } from 'react-router-dom'

class PostContainer extends React.Component {
  render() {
    const { loading } = this.props
    if (loading) return <Loading />
    const {
      provincial: { post },
      site: { news = [] }
    } = this.props

    if (!post) {
      return <Redirect to={'/not-found'}/>
    }

    return (
      <React.Fragment>
        <MetaHeader site={this.props.site} p={post} />
        <Article news={news} post={post} />
      </React.Fragment>
    )
  }
}

const POST_QUERY = gql`
  query getPost($site: String!, $slug: String!) {
    provincial(site: $site) {
      post(slug: $slug) {
        id
        formattedDate
        seo
        title {
          rendered
        }
        excerpt {
          rendered
        }
        content {
          rendered
        }
        featured_media {
          id
          source_url
          title {
            rendered
          }
        }
        category {
          id
          slug
          taxonomy
          name
        }
        tag {
          id
          slug
          taxonomy
          name
        }
        meta {
          person {
            member
            role
            hasMember
          }
        }
        province {
          name
        }
      }
    }
  }
`

const withPost = graphql(POST_QUERY, {
  options: props => {
    let url
    if (process.browser) {
      url = window.location.host
    } else {
      url = props.url
    }

    return {
      variables: {
        slug: props.match.params.slug,
        taxInput: { taxonomy: 'categories' },
        site: url
      }
    }
  },
  props: ({ data }) => ({ ...data })
})

export default withPost(PostContainer)
